import React from 'react';
import { MAINTENANCE_CONFIG } from '../utils/constants';
import BetaAccessDrawer from '../components/maintenance/BetaAccessDrawer';
import './MaintenancePage.css';

const MaintenancePage: React.FC = () => {
  return (
    <div className="maintenance-page">
      <div
        className="maintenance-page__background"
        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/cow_swizz.jpg)` }}
        aria-hidden="true"
      />
      <div className="maintenance-page__overlay" aria-hidden="true" />
      <div className="maintenance-page__split">
        <div className="maintenance-page__left">
          <div className="maintenance-page__welcome">
            <div className="maintenance-page__logo">
              <img
                src="/image_i_do1.png"
                alt="Luci logo"
                className="luci-logo"
              />
            </div>
            <h1 className="maintenance-page__title">Scheduled maintenance</h1>
            <p className="maintenance-page__message">{MAINTENANCE_CONFIG.MESSAGE}</p>
          </div>
        </div>
        <div className="maintenance-page__right" aria-hidden="true" />
      </div>

      <BetaAccessDrawer />
    </div>
  );
};

export default MaintenancePage;
